<script>
  import { derived, writable, readable } from 'svelte/store'
  import { createTable, createRender, Subscribe, Render } from 'svelte-headless-table'
  import {addSortBy} from 'svelte-headless-table/plugins'
  import { fade } from 'svelte/transition'
  import Api from './services/Api.js'
  import { formatPrice } from './helpers.js'
  import {isAdmin, currentSheet, locations} from './stores/root.js'
  import { exportSheet } from './stores/sheet'
  import ReportTable from './ReportTable.svelte'
  import EditableCell from './EditableCell.svelte'
  import ActionsCell from './ActionsCell.svelte'

  const editingRows = writable([]);
  const EditableCellLabel = ({ column, row, value })  => createRender(EditableCell, {
    detail: row.original.detail,
    column: column,
    value: value,
    editingRows: editingRows,
  }) 

  const ActionsCellLabel = ({column, row, value}) => createRender(ActionsCell, {
    itemName: row.original.name,
    detail: row.original.detail,
    column: column,
    value: value,
    editingRows: editingRows
  })

  const tableConfig = {
    sort: addSortBy({
      initialSortKeys: [
        {id: 'name', order: 'asc'}
      ]
    })
  }

  const tableColumns = [
    {
      header: 'Item',
      accessor: 'name'
    },
    {
      header: 'Retail Price',
      accessor: (row) => row.detail?.price,
      cell: ({value}) => `$${formatPrice(value)}`
    },
    {
      id: 'cost',
      header: 'Cost',
      accessor: (row) => row.detail?.cost,
      cell: EditableCellLabel
    },
    {
      id: 'vendor',
      header: 'Vendor',
      accessor: (row) => row.detail?.vendor?.id,
      cell: EditableCellLabel
    },
    {
      id: 'qtyStart',
      header: 'Qty Start',
      accessor: (row) =>  row.detail?.qtyStart,
      cell: EditableCellLabel
    },
    {
      id: 'qtySold',
      header: 'Qty Sold',
      accessor: (row) => row.detail?.qtySold,
      cell: EditableCellLabel
    },
    {
      id: 'shrink',
      header: 'Shrink',
      accessor: (row) => row.detail?.shrink,
      cell: EditableCellLabel
    },
    // {
    //   header: 'Sales',
    //   accessor: (row) =>  row.detail?.sales,
    //   cell: ({value})  => `$${formatPrice(value)}`
    // },
    {
      id: 'donate',
      header: 'Donate',
      accessor: (row) => row.detail?.donate,
      cell: EditableCellLabel
    },
    {
      id: 'resell',
      header: 'Resell',
      accessor: (row) => row.detail?.resell,
      cell: EditableCellLabel
    },
    {
      id: 'notes',
      header: 'Notes',
      accessor: (row) => row.detail?.notes,
      cell: EditableCellLabel
    },

  ]

  // Once a sheet is closed, the Donate and Resell columns are no longer relevant.
  if ($currentSheet.closed) {
    for (const id of ['donate', 'resell']) {
      const idx = tableColumns.findIndex((column) => column.id === id)
      if (idx !== -1) tableColumns.splice(idx, 1)
    }
  }

  if ($currentSheet.exported === false) {
    tableColumns.push({
      header: '',
      cell: ActionsCellLabel
    })
  }
  
  const tableData = {}
  $locations.forEach((location) => {
    const data = derived(currentSheet, ($sheet) => {
      const items = $sheet.items.filter((item) => item.details.some((detail) => detail.location == location.id))
      return items.map((item) => {
        const detail = item.details.find((detail) => detail.location == location.id) || false;

        return {
          itemId: item.id,
          name: item.name + (!item.variationName || item.variationName === 'Regular' ? '' : `, ${item.variationName}`),
          resell: item.resell,
          detail: {
            ...detail,
            sales: detail.qtySold ? detail.qtySold * detail.price : 0
          }
        }
      }).filter((item) => item !== false)
    })

    tableData[location.id] = data
  })
</script>

<div in:fade={{ duration: 500 }}>
  <div class="row mt-3 mb-5">
    <div class="col-9 fs-3 mb-3 mb-sm-0">
      {$currentSheet.displayDate}
      {#if $currentSheet.closed && !$currentSheet.exported}
        <span class="badge bg-secondary ms-2">Closed</span>
      {:else if ($currentSheet.exported)}
        <span class="badge bg-primary ms-2">Exported</span>
      {/if}
    </div>
    {#if $currentSheet.exported === false}
      <div class="col-3 d-flex justify-content-end">
        <button
          class="btn btn-primary"
          on:click={(e) => exportSheet($currentSheet.id)}>Export Data</button
        >
      </div>
    {/if}
  </div>
  <ul class="nav nav-tabs" id="location-tabs" role="tablist">
    {#each $locations as location, i}
      <li class="nav-item">
        <button
          class={'nav-link' + (i == 0 ? ' active' : '')}
          data-bs-toggle="tab"
          data-bs-target={`#location-${location.id}`}
        >
          {location.name}
        </button>
      </li>
    {/each}
  </ul> 

  <div class="tab-content p-3 border border-top-0">
  {#each $locations as location, i}
    <div
      class={'tab-pane fade' + (i == 0 ? ' show active' : '')}
      id={`location-${location.id}`}
    >
      <ReportTable config={tableConfig} columns={tableColumns} data={tableData[location.id]} />
    </div>
  {/each}
  </div>
</div>